import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RunningOrders from '../components/RunningOrders/';
import SidebarState from '../constants/sidebarState';
import { actions as appActions } from '../actions/app';
import { actions as assetActions } from '../actions/asset';
import { actions as runningOrderActions } from '../actions/runningOrder';
import LoadingIndicator from '../components/LoadingIndicator';
import { Container } from '../styled-components/Layout';
import SlidingOverlay from '../components/SlidingOverlay';
import EditorLayout from './EditorLayout';
import AppMode from '../constants/appMode';

class RunningOrdersLayout extends React.Component {
  constructor() {
    super();

    this.state = {
      editorWindowVisible: false,
      selectedAssetId: null,
      loading: false
    };
  }
  componentDidMount() {
    this.props.changeSidebarState(SidebarState.NONE);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.appMode === AppMode.EDIT &&
      nextProps.appMode === AppMode.NORMAL
    ) {
      this.setState({ selectedAssetId: null });
      this.props.clearAsset();
    }

    if (
      this.props.appMode === AppMode.NORMAL &&
      nextProps.appMode === AppMode.EDIT
    ) {
      this.setState({ loading: false });
    }
  }

  onComplete = () => {
    this.setState({ selectedAssetId: null });
    this.props.getRunningOrder(this.props.selectedRunningOrder);
  };

  closeEditorDialog = () => {
    this.props.setAppMode(AppMode.NORMAL);
    this.setState({ selectedAssetId: null });
    this.props.getRunningOrder(this.props.selectedRunningOrder);
  };

  openEditor = mosObjectId => {
    this.setState({ loading: true });
    this.props
      .loadEditor(mosObjectId, true)
      .then(() => this.props.setAppMode(AppMode.EDIT))
      .catch(error => console.log(error));
    this.setState({ selectedAssetId: mosObjectId });
  };

  render() {
    return (
      <Container>
        <LoadingIndicator visible={this.state.loading} />
        <Container>
          <SlidingOverlay visible={this.props.appMode === AppMode.EDIT}>
            <EditorLayout
              onComplete={this.onComplete}
              assetId={this.state.selectedAssetId}
              overlay
            />
          </SlidingOverlay>
          <RunningOrders openEditor={this.openEditor} />
        </Container>
      </Container>
    );
  }
}

RunningOrdersLayout.defaultProps = {
  selectedAssetId: null
};

RunningOrdersLayout.propTypes = {
  changeSidebarState: PropTypes.func.isRequired,
  loadEditor: PropTypes.func.isRequired,
  setAppMode: PropTypes.func.isRequired,
  appMode: PropTypes.string.isRequired,
  getRunningOrder: PropTypes.func.isRequired,
  selectedRunningOrder: PropTypes.string.isRequired,
  clearAsset: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  appMode: state.app.appMode,
  selectedRunningOrder:
    state.runningOrder.runningOrder && state.runningOrder.runningOrder.id
      ? state.runningOrder.runningOrder.id
      : '-1'
});

const mapActionCreators = {
  changeSidebarState: appActions.changeSidebarState,
  loadEditor: assetActions.loadEditor,
  setAppMode: appActions.setAppMode,
  getRunningOrder: runningOrderActions.getRunningOrder,
  clearAsset: assetActions.clearAsset
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(RunningOrdersLayout);



// WEBPACK FOOTER //
// ./app/layouts/RunningOrdersLayout.js